import { useState, useEffect } from 'react';
import Card from '@mui/material/Card';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import { IconButton, ListItemText, TableCell } from '@mui/material';
import Container from '@mui/material/Container';
import { paths } from 'src/routes/paths';
import { useBoolean } from 'src/hooks/use-boolean';
import Iconify from 'src/components/iconify';
import { ConfirmDialog } from 'src/components/custom-dialog';
import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
import { RouterLink } from 'src/routes/components';
import Stack from '@mui/material/Stack';
import { enqueueSnackbar } from 'notistack';
import Label from 'src/components/label/label';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import axiosInstance, { API_ENDPOINTS } from 'src/utils/axios';
import { format } from 'date-fns';
import { useRouter } from 'src/routes/hook';
import { pt } from 'date-fns/locale';
import DishCategoryQuickForm from '../ementas-form';


function getIdRenderized(params) {
  const formated = params.id.split("-")[0];
  return (<Label title={params.id} variant="soft" color='primary' >{formated}</Label>);
}
export default function EmentasListView() {
  const [tableData, setTableData] = useState([]);
  const [currentData, setCurrentData] = useState({});
  const [toDeleteItem, setToDeleteItem] = useState();
  const quickEdit = useBoolean();
  const router = useRouter();
  const quickTypeForm = useBoolean();
  const handleEdit = async (params) => {
    router.push(paths.dashboard.ementas.edit(params.id))
  };
  const handleDelete = (params) => {
    setToDeleteItem(params.id);
    confirm.onTrue();
  };
  const confirmDelete = async () => {
    try {
      await axiosInstance.delete(`${API_ENDPOINTS.menu.delete}/${toDeleteItem}`);
      setToDeleteItem();
      enqueueSnackbar(`Menu eliminado com sucesso.`,'success');
     } catch (error) {
      enqueueSnackbar(`Não foi possível eliminar o menu.`,'error');
     }

     fetchData();
  };
  const handleOnClose = () => {
    setCurrentData({});
    quickEdit.onFalse()
    fetchData();
  };
  function getModifiedDateRenderized(params) {
    if(params.row.modifiedAt === null)
    {
      return ( <TableCell> <Label variant="soft" color='default'>Sem Alteração</Label> </TableCell>);
    }
    if(params.row.modifiedAt !== null)
    {
    return (
      <TableCell>
            <ListItemText
              primary={format(new Date(params.row.modifiedAt), 'dd MMM yyyy', {locale:pt})}
              secondary={format(new Date(params.row.modifiedAt), 'p', {locale:pt})}
              primaryTypographyProps={{ typography: 'body2', noWrap: true }}
              secondaryTypographyProps={{
                mt: 0.5,
                component: 'span',
                typography: 'caption',
              }}
            />
          </TableCell>
    )
  }
    return (<div> </div>);
  }
  function getCreatedDateRenderized(params) {
  
    return (
      <TableCell>
            <ListItemText
              primary={format(new Date(params.row.creationDate), 'dd MMM yyyy', {locale:pt})}
              secondary={format(new Date(params.row.creationDate), 'p', {locale:pt})}
              primaryTypographyProps={{ typography: 'body2', noWrap: true }}
              secondaryTypographyProps={{
                mt: 0.5,
                component: 'span',
                typography: 'caption',
              }}
            />
          </TableCell>
    )
  }
  function quickActions(params) {
    return ( <div>
      <Tooltip title="Editar" placement="top" arrow>
        <IconButton color={quickEdit.value ? 'inherit' : 'default'} onClick={() => handleEdit(params)}>
          <Iconify icon="solar:pen-bold" />
        </IconButton>
      </Tooltip>
      <Tooltip title="Eliminar" placement="top" arrow>
      <IconButton onClick={() => handleDelete(params)}>
        <Iconify icon="solar:trash-bin-trash-bold" />
      </IconButton>
    </Tooltip></div>
    );
  }
  const columns = [
    { field: 'id', headerName: 'Id' , maxWidth:100, renderCell:getIdRenderized, align: 'left',headerAlign: 'left', hide: true},
    { field: 'type', headerName:'Tipo de Ementa', flex:1, align: 'left'},
    { field: 'categoryCount', headerName:'Nº de Categorias', flex:1, align: 'left'},
    { field: 'dishCount', headerName:'Nº de Pratos', flex:1, align: 'left'},
    { field: 'creationDate', headerName: 'Data de Criação',  flex:1, align: 'left',headerAlign: 'left', renderCell: getCreatedDateRenderized},
    { field: 'modifiedAt', headerName: 'Data de Alteração',  flex:1, align: 'left',headerAlign: 'left', renderCell: getModifiedDateRenderized},
    {  field:'', headerName:'Ações',  flex:1 , align: 'center',headerAlign: 'center', renderCell: quickActions
    },
  ]
  const fetchData = async () => {
    try {
      const res = await axiosInstance.get(API_ENDPOINTS.menu.list);
     setTableData(res.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);


  const settings = useSettingsContext();
  const confirm = useBoolean();
  return (
    <>
      <Container maxWidth={settings.themeStretch ? false : 'lg'}>
        <CustomBreadcrumbs
          heading="Lista de Ementas"
          links={[
            { name: 'Dashboard', href: paths.dashboard.root },
            { name: 'Ementas', href: paths.dashboard.ementas.list },
            { name: 'Lista' },
          ]}
          action={
           
            <Button
            component={RouterLink}
            href={paths.dashboard.ementas.create}
            variant="contained"
            startIcon={<Iconify icon="mingcute:add-line" />}
          >
            Nova Ementa
          </Button>
          }
          sx={{
            mb: { xs: 3, md: 5 },
          }}
        />
        {quickEdit.value ? <DishCategoryQuickForm current={currentData}  open={quickEdit.value} onClose={() => { handleOnClose() }} isEdit={quickTypeForm.value}/> : '' }
        <Card>
        <div style={{ minHeight: 400, width: "100%" }}>
            <DataGrid
            getRowId={(row) => row.id}
            rowSelection={false}
            rows={tableData}
            columns={columns}
            slots={{
              toolbar: GridToolbar,
              noResultsOverlay: () => (
                <Stack height="100%" alignItems="center" justifyContent="center">
                  Sem Resultados
                </Stack>
              ),
              noRowsOverlay: () => (
                <Stack height="100%" alignItems="center" justifyContent="center">
                  Sem Resultados
                </Stack>
              )
              ,
            }} 
            disableColumnFilter
            disableColumnSelector
            disableDensitySelector
            slotProps={{
              toolbar: {
                showQuickFilter: true,
              },
            }}
            disableSelectionOnClick
            />
            </div>
        </Card>
      </Container>
      <ConfirmDialog
        open={confirm.value}
        onClose={confirm.onFalse}
        title="Eliminar"
        content={
          <>
           Tem a certeza que deseja eliminar este tipo de menu?
          </>
        }
        action={
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              confirmDelete();
              confirm.onFalse();
            }}
          >
            Eliminar
          </Button>
        }
      />
    </>
  );
}
